import Div100vh from 'react-div-100vh'
import styled from 'styled-components'

// ApplicationGrid sets the vertical layout for:
//   - title bar
//   - TaskWrapper
const ApplicationGrid = styled(Div100vh)`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  height: 100rvh; /* rvh unit is specific to Div100vh component */
  width: 100vw;
  overflow: hidden;
`

ApplicationGrid.displayName = 'ApplicationGrid'

export default ApplicationGrid
